export const normalizeLogin = (login: string) => {
  if (/^\+?[0-9]+$/.test(login)) {
    let parsedLogin = login.replace("+", "");

    if (parsedLogin.length === 11 && parsedLogin.startsWith("8")) {
      parsedLogin = "7" + parsedLogin.slice(1);
    }
    return parsedLogin;
  }

  return "";
};

export function validateInputToNumberType(event: any) {
  const theEvent = event;
  let key = theEvent.keyCode || theEvent.which;
  key = String.fromCharCode(key);
  const regex = /[0-9]|\./;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
}
